import React, { useCallback } from "react";
import { Paths } from "../../../../../Paths";
import { AddButton } from "../../../common/button/AddButton";
import { useNavigate } from "react-router-dom";

export const CareRecipientAdd = React.memo(function CareRecipientAdd() {
    const navigate = useNavigate();

    const handleAddButtonClicked = useCallback(() => navigate(`${Paths.admin}${Paths.careRecipient}${Paths.add}`), [navigate]);

    return (
        <div className="add" onClick={handleAddButtonClicked}>
            <AddButton label="追加する" onClick={handleAddButtonClicked} />
        </div>
    );
});
